import { injectBaseConstantMethods } from "./BaseConstants"

const UserTypes = {
   USER: "USER",
   WAREHOUSE: "WAREHOUSE_MANAGER",
   DEPARTMENT: "DEPARTMENT_MANAGER",
   ADMIN: "ADMIN",
   FINANCE: "FINANCE_MANAGER",
   EXECUTIVE: "EXECUTIVE",
   SUPER_ADMIN: "SUPER_ADMIN",
   PLANT_MANAGER: "PLANT_MANAGER",
   ASSISTANT_PLANT_MANAGER: "ASSISTANT_PLANT_MANAGER",
}

const displayTextKeys = {
   [UserTypes.ADMIN]: "Admin",
   [UserTypes.DEPARTMENT]: "Station",
   [UserTypes.FINANCE]: "Finance",
   [UserTypes.EXECUTIVE]: "Executive",
   [UserTypes.WAREHOUSE]: "Warehouse",
   [UserTypes.USER]: "User",
   [UserTypes.SUPER_ADMIN]: "Super Admin",
   [UserTypes.PLANT_MANAGER]: "Plant Manager",
   [UserTypes.ASSISTANT_PLANT_MANAGER]: "Asst. Plant Manager",
}

const labelClass = {}

export default injectBaseConstantMethods(UserTypes, displayTextKeys, labelClass)
